// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-error-container {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
}

.input-error-container__icon {
    width: 0.7em;
    height: 0.7em;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/inputErrorMessage/InputErrorMessage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".input-error-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.input-error-container__icon {\n    width: 0.7em;\n    height: 0.7em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
